import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: null,
})
export class LoadingLayerService {
    private layerVisible = new BehaviorSubject<boolean>(false);

    public isLayerVisible() {
        return this.layerVisible.asObservable();
    }

    public showLayer() {
        this.layerVisible.next(true);
    }

    public hideLayer() {
        this.layerVisible.next(false);
    }
}
